module.exports = __webpack_public_path__ + "img/09.b.d41083dd.webp";